export const iconFontAwesomeReligionBookBible = (
	<i className="fa-solid fa-book-bible"></i>
);
